const getKPIFiltersWithDefaults = (kpiResult) => {
    var _a;
    const filters = ((_a = kpiResult === null || kpiResult === void 0 ? void 0 : kpiResult.kpiConfig) === null || _a === void 0 ? void 0 : _a.filters) || {};
    return {
        originators: filters.originators || [],
        priorities: filters.priorities || [],
        reasons: filters.reasons || [],
        controlledTransfersOnly: filters.controlledTransfersOnly || false,
        blindTransfersOnly: filters.blindTransfersOnly || false,
        handoffTransfersOnly: filters.handoffTransfersOnly || false,
    };
};
const getKPIThresholdsWithDefaults = (kpiResult) => {
    var _a;
    const thresholds = ((_a = kpiResult === null || kpiResult === void 0 ? void 0 : kpiResult.kpiConfig) === null || _a === void 0 ? void 0 : _a.thresholds) || {};
    return {
        excellent: thresholds.excellent || 5,
        good: thresholds.good || 15,
        acceptable: thresholds.acceptable || 30,
    };
};
export const filterInteractionsForKPI = (interactions, kpiResult) => {
    const filters = getKPIFiltersWithDefaults(kpiResult);
    return interactions.filter((interaction) => {
        if (filters.originators.length > 0) {
            if (!filters.originators.includes(interaction.ToFilterOriginator || ""))
                return false;
        }
        if (filters.priorities.length > 0) {
            if (!filters.priorities.includes(interaction.ToFilterPriority || ""))
                return false;
        }
        if (filters.reasons.length > 0) {
            if (!filters.reasons.includes(interaction.ToFilterReason || ""))
                return false;
        }
        if (filters.controlledTransfersOnly) {
            const action = interaction.InteractionFinalAction || "";
            const normalizedAction = action.replace(/\s+/g, "");
            if (normalizedAction !== "ControlledTransfer")
                return false;
        }
        if (filters.blindTransfersOnly) {
            const action = interaction.InteractionFinalAction || "";
            const normalizedAction = action.replace(/\s+/g, "");
            if (normalizedAction !== "BlindTransfer")
                return false;
        }
        if (filters.handoffTransfersOnly) {
            const action = interaction.InteractionFinalAction || "";
            const normalizedAction = action.replace(/\s+/g, "");
            if (normalizedAction !== "HandoffTransfer")
                return false;
        }
        return true;
    });
};
export const calculateKPIMetrics = (interactions, kpiResult) => {
    const kpiInteractions = filterInteractionsForKPI(interactions, kpiResult);
    let excellent = 0;
    let good = 0;
    let acceptable = 0;
    let poor = 0;
    if (kpiInteractions.length > 0) {
        const thresholds = getKPIThresholdsWithDefaults(kpiResult);
        const { excellent: excellentThreshold, good: goodThreshold, acceptable: acceptableThreshold } = thresholds;
        kpiInteractions.forEach((interaction) => {
            if (interaction.SecureMessageReadUtc && interaction.InteractionStartDateUtc) {
                const responseTimeMinutes = (new Date(interaction.SecureMessageReadUtc).getTime() -
                    new Date(interaction.InteractionStartDateUtc).getTime()) /
                    (1000 * 60);
                if (responseTimeMinutes <= excellentThreshold) {
                    excellent++;
                }
                else if (responseTimeMinutes <= goodThreshold) {
                    good++;
                }
                else if (responseTimeMinutes <= acceptableThreshold) {
                    acceptable++;
                }
                else {
                    poor++;
                }
            }
        });
    }
    const total = excellent + good + acceptable + poor;
    const excellentPercent = total > 0 ? `${Math.round((excellent / total) * 100)}%` : "0%";
    const goodPercent = total > 0 ? `${Math.round((good / total) * 100)}%` : "0%";
    const acceptablePercent = total > 0 ? `${Math.round((acceptable / total) * 100)}%` : "0%";
    const poorPercent = total > 0 ? `${Math.round((poor / total) * 100)}%` : "0%";
    return {
        excellent,
        good,
        acceptable,
        poor,
        excellentPercent,
        goodPercent,
        acceptablePercent,
        poorPercent,
    };
};
//# sourceMappingURL=kpiCalculationUtils.js.map